/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const VideoCameraIconOutline = createIcon({
  displayName: 'VideoCameraIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M16,10.29248l3.47522-2.14215A1,1,0,0,1,21,9.00159v6.99682a1,1,0,0,1-1.52472.85126L16,14.70746"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="5.99997"
        width="13"
        height="13"
        rx="3"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
})

const VideoCamera: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={VideoCameraIconOutline} {...props} />
  }
}

export default memo(VideoCamera)
